/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateIntroductionInquiryDto } from '../../models/create-introduction-inquiry-dto';
import { IntroductionInquiryDto } from '../../models/introduction-inquiry-dto';

export interface IntroductionInquiryControllerCreate$Params {
      body: CreateIntroductionInquiryDto
}

export function introductionInquiryControllerCreate(http: HttpClient, rootUrl: string, params: IntroductionInquiryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<IntroductionInquiryDto>> {
  const rb = new RequestBuilder(rootUrl, introductionInquiryControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntroductionInquiryDto>;
    })
  );
}

introductionInquiryControllerCreate.PATH = '/api/introduction-inquiry';
